import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom-v5-compat";
import {
  FlightSearchSelectors,
  setSearchFormDestination,
  setSearchFormOrigin,
} from "@b2bportal/core-flights";
import type { ITripTerminus } from "@b2bportal/core-types";
import { FLIGHTS_PATH } from "@hsbc/utilities";

export interface UseSearchLocationParams {
  isOrigin?: boolean;
}

export interface UseSearchLocationResponse {
  context: {
    titleKey: string;
    selectedLocation: ITripTerminus;
  };
  handlers: {
    onChange: (location: ITripTerminus) => void;
  };
}

/**
 * This hook is only used for flights search.
 * To support other funnels, please update navigate destination.
 */
export const useSearchLocation = ({
  isOrigin = false,
}: UseSearchLocationParams): UseSearchLocationResponse => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { origin, destination } = useSelector(
    FlightSearchSelectors.getSearchState
  );

  const onOriginChange = (origin: ITripTerminus) => {
    dispatch(setSearchFormOrigin(origin));
    navigate(FLIGHTS_PATH);
  };

  const onDestinationChange = (destination: ITripTerminus) => {
    dispatch(setSearchFormDestination(destination));
    navigate(FLIGHTS_PATH);
  };

  return {
    context: {
      titleKey: `searchControl.${isOrigin ? "whereFrom" : "whereTo"}`,
      selectedLocation: isOrigin ? origin : destination,
    },
    handlers: {
      onChange: isOrigin ? onOriginChange : onDestinationChange,
    },
  };
};
